
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Futsal Tournament </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2> Successful Conclusion of the G H Raisoni Memorial
                <span >Futsal Tournament – 2023  </span></h2>
        </div>
        <!-- <p>Nagpur| September 03: G H Raisoni Sports and Cultural Foundation in association with Nagpur Archery Association, is organising ‘G H Raisoni Memorial Archery Tournament, 2023’ on 3rd September, 2023, at 8:30 am on the G H Raisoni Institute of Engineering and Technology campus.</p>
       <p>G H Raisoni Memorial Archery Tournament is open to participant’s age-group Under 9, Under 11, Under 14, Under 17, and Under 19 and open. The tournament offers certificates, medals and making it an enticing and rewarding experience for the participating archers. The aim of the event is to promote sportsmanship skills among young talents in the field of archery.</p>
        <p>The organizers have meticulously planned the event to ensure adherence to all necessary safety protocols,ensuring a secure environment for all participants and attendees. The Archery Tournament 2023 promises to be a thrilling display of skill and precision as talented archers from various regions participate in the competition.</p>
        <p>To register click the link below :- <a href="https://forms.gle/Qq8V9yxdaqA7Gvyd8">https://forms.gle/Qq8V9yxdaqA7Gvyd8</a></p> -->
        <p class="text-justify"> The G H Raisoni Sports & Cultural Foundation, in collaboration with the Bhandara
            District Amateur Football Association, successfully completed the 'G H Raisoni Memorial Futsal Tournament'
            held on August 26th and 27th, 2023, at the Shivaji Stadium, Main Road, Bhandara.</p>
        <p class="text-justify">The tournament, designed to promote healthy competition and teamwork, featured
            participants in the U17 and U19 age groups, encompassing both Inter School and Inter Club categories. This
            inclusive approach provided an invaluable platform for emerging football talents to showcase their skills
            and passion for the sport.</p>
        <p class="text-justify">With the unwavering support of the Bhandara District Amateur Football Association, the
            tournament not only entertained football enthusiasts but also highlighted the promising potential of the
            region's young athletes.</p>
        <p class="text-justify">The participating teams displayed exceptional dedication and sportsmanship throughout
            the tournament, making the event a true celebration of football. We are pleased to announce the following
            winners:</p>



        <div class="row row-cols-1 row-cols-md-3">

            <div class="col">
                <h6 class="fw-bold">U17 Category:</h6>
                <ul class="list-style list-style1">
                    <li>1st Place: Sunflag FC</li>
                    <li>2nd Place: Eagle Varthi FC</li>
                    <li>3rd Place: SSDS FC</li>
                </ul>
            </div>
            <div class="col">
                <h6 class="fw-bold">U19 Category:</h6>
                <ul class="list-style list-style1">
                    <li>1st Place: RSSGK FC</li>
                    <li>2nd Place: Youngstar FC</li>
                    <li>3rd Place: Bhandara City</li>
                </ul>
            </div>
            <div class="col">
                <h6 class="fw-bold"> Indian Round Under 14:-</h6>
                <ul class="list-style list-style1">
                    <li>Rajnit Bharat Gomase (Gold)</li>
                    <li>Vinit Chandrakant dehalikar (Silver)</li>
                    <li>Anant Sujeet Chourasia (Bronze)</li>
                </ul>
            </div>

        </div>
        <p class="text-justify">The winners were awarded with cash prizes, trophies, and medals, recognizing their
            outstanding achievements. The G H Raisoni Sports & Cultural Foundation would like to extend its heartfelt
            appreciation to all participants, sponsors, and supporters for making this tournament a resounding success.
        </p>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col">
                <div class="gall-ery">
                    <div class="widget_title inner-title gall-sys shadow-text-sm">
                        <h4 class="fw-bold">Media Coverage</h4>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/media-3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="col">

                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <a href="/photogallery#FutsalTournament" class="cmn-white-button"><span>
                                    View More</span>
                            </a>
                        </div>

                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal9.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal9.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal9.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal6.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal6.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal6.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal4.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal4.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal4.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal2.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal2.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal2.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal3.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal3.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal3.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal5.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal5.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal5.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal8.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal8.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal8.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal1.webp"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal1.webp">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/Fustal/futsal1.webp"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
